import { createFileRoute } from "@tanstack/react-router";
import { StackPage } from "@/components/architecture/stack-page";

export const Route = createFileRoute("/_app/$workspaceSlug/stack")({
  component: StackRoute,
});

function StackRoute() {
  const { workspaceSlug } = Route.useParams();
  return <StackPage key={workspaceSlug} />;
}
